<div class="ap-page">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="ap-loading" *ngIf="!ready">
    <div class="ap-loading__icon"><mat-icon>receipt</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="ap-loading__text">Cargando formulario…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER ─────────────────────────────────────────────── -->
    <div class="ap-header">
      <div class="ap-header__icon"><mat-icon>receipt</mat-icon></div>
      <div>
        <h1 class="ap-header__title">{{ advancePayment.uid ? 'Editar anticipo' : 'Nuevo anticipo a proveedor' }}</h1>
        <p class="ap-header__sub">{{ advancePayment.uid ? 'Modifica los datos del anticipo' : 'Registra un anticipo a proveedor' }}</p>
      </div>

      <div class="ap-header__summary" *ngIf="advancePayment.advancedPaymentLines?.length > 0">
        <div class="ap-header__summary-item">
          <span class="ap-header__summary-label">Subtotal</span>
          <span class="ap-header__summary-value">{{ calcularSubtotal() }}</span>
        </div>
        <div class="ap-header__summary-divider"></div>
        <div class="ap-header__summary-item">
          <span class="ap-header__summary-label">Total</span>
          <strong class="ap-header__summary-value ap-header__summary-value--total">{{ calcularTotal() }}</strong>
        </div>
      </div>

      <button mat-flat-button class="ap-btn-save" (click)="save(advancePayment)">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="ap-body">
      <div class="ap-grid">

        <!-- COLUMNA IZQUIERDA -->
        <div class="ap-left">

          <!-- SECCIÓN: Proveedor y fecha -->
          <div class="ap-section">
            <div class="ap-section__head">
              <mat-icon>business</mat-icon>
              <span>Proveedor y fecha</span>
            </div>
            <div class="ap-section__body">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Proveedor</mat-label>
                <input matInput [(ngModel)]="advancePayment.providerName"
                  [matAutocomplete]="autoAP" [formControl]="advancePaymentForm" required>
                <mat-autocomplete #autoAP="matAutocomplete">
                  <mat-option *ngFor="let contact of filteredContacts | async; trackBy: trackByIndex" [value]="contact.companyName">
                    {{ contact.companyName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha</mat-label>
                <input matInput [matDatepicker]="invoiceRelease" name="advancePayment.date"
                  [(ngModel)]="advancePayment.date" required>
                <mat-datepicker-toggle matSuffix [for]="invoiceRelease"></mat-datepicker-toggle>
                <mat-datepicker #invoiceRelease></mat-datepicker>
              </mat-form-field>

            </div>
          </div>

          <!-- SECCIÓN: Pago -->
          <div class="ap-section">
            <div class="ap-section__head">
              <mat-icon>credit_card</mat-icon>
              <span>Pago</span>
            </div>
            <div class="ap-section__body">

              <app-select name="advancePayment.typePay" [(ngModel)]="advancePayment.typePay"
                [config]="{ label: 'Tipo de pago', placeholder: 'Seleccionar', required: true, options: payMethodsOptions }">
              </app-select>

              <ng-container *ngIf="advancePayment.typePay === 'Efectivo'">
                <app-autocomplete-select [items]="efectivoList" [(selectedItemId)]="advancePayment.efectivoId"
                  [idField]="'uid'" [displayField]="'nombre'" placeholder="Caja / Efectivo" class="w-100">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="advancePayment.typePay === 'Socio'">
                <app-autocomplete-select [items]="sociosList" [(selectedItemId)]="advancePayment.partnersId"
                  [idField]="'uid'" [displayField]="'nameOrBusinessName'" placeholder="Socio" class="w-100">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="advancePayment.typePay === 'Transferencia bancaria'
                  || advancePayment.typePay === 'Cargo en cuenta'
                  || advancePayment.typePay === 'Confirming'
                  || advancePayment.typePay === 'Pagarés'">
                <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="advancePayment.typePayBankAccount"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']" placeholder="Cuenta bancaria" class="w-100">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="advancePayment.typePay === 'Tarjeta de crédito'">
                <app-autocomplete-select [items]="paymentCards" [(selectedItemId)]="advancePayment.typePayBankAccount"
                  [idField]="'uid'" [displayField]="'number'" placeholder="Tarjeta de crédito" class="w-100">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="advancePayment.typePay === 'Tarjeta de débito'">
                <app-autocomplete-select [items]="paymentCards" [(selectedItemId)]="advancePayment.typePayBankAccount"
                  [idField]="'uid'" [displayField]="'number'" placeholder="Tarjeta de débito" class="w-100">
                </app-autocomplete-select>
              </ng-container>

            </div>
          </div>

        </div>

        <!-- COLUMNA DERECHA -->
        <div class="ap-right">

          <!-- SECCIÓN: Importes -->
          <div class="ap-section">
            <div class="ap-section__head">
              <mat-icon>receipt</mat-icon>
              <span>Importes</span>
              <app-help key='Ingresos13' class="ap-section__head-help"></app-help>
            </div>
            <div class="ap-section__body">

              <div *ngFor="let item of advancePayment.advancedPaymentLines; index as i; trackBy: trackByIndex" class="ap-line">
                <div class="ap-line__info">
                  <div class="ap-line__product">{{ item.product || '—' }}</div>
                  <div class="ap-line__meta">
                    <span>{{ item.quantity }} ud. × {{ item.unityAmount }}</span>
                    <span *ngIf="item.discount > 0"> · Dto {{ item.discount }}%</span>
                    <span *ngIf="item.taxes?.length > 0"> · {{ getStrTaxes(item.taxes) }}</span>
                  </div>
                </div>
                <div class="ap-line__total">{{ calcularTotalesLinea(item) }}</div>
                <div class="ap-line__actions">
                  <button mat-icon-button class="ap-icon-btn ap-icon-btn--edit" (click)="toggleEditMode(i)" matTooltip="Editar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button class="ap-icon-btn ap-icon-btn--delete" (click)="removeInvoiceLine(item)" matTooltip="Eliminar">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

              <div class="ap-line-actions">
                <button mat-stroked-button class="ap-btn-add-line" (click)="addInvoiceLine()">
                  <mat-icon>add</mat-icon> Añadir concepto
                </button>
              </div>

              <!-- Totales -->
              <div class="ap-totals" *ngIf="advancePayment.advancedPaymentLines?.length > 0">
                <div class="ap-totals__row">
                  <span class="ap-totals__label">Subtotal</span>
                  <span class="ap-totals__value">{{ calcularSubtotal() }}</span>
                </div>
                <div *ngFor="let taxView of impuestos(); trackBy: trackByIndex" class="ap-totals__row">
                  <span class="ap-totals__label">{{ taxView }}</span>
                </div>
                <div class="ap-totals__row ap-totals__row--final">
                  <span class="ap-totals__label">Total</span>
                  <strong class="ap-totals__value ap-totals__value--total">{{ calcularTotal() }}</strong>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>

  </ng-container>

</div>
